<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">رسیدهای تایید نهایی شده</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label>نام مشتری</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="برای جستجو، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-6">
          <label>وضعیت فاکتور</label>
          <select [(ngModel)]="factorConfirmFilter" (ngModelChange)="onFactorConfirmFilterChange()"
            name="factorConfirmFilter" class="custom-select" [disabled]="loading">
            <option [ngValue]="0">رسید های فاکتور نشده</option>
            <option [ngValue]="1">رسید های فاکتور شده</option>
            <option [ngValue]="-1">همه موارد</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button type="button" (click)="getList()" class="btn btn-info" style="margin-left: 5px;"
            [disabled]="loading"><i class="fa fa-search"></i> جستجوی اطلاعات</button>
          <img *ngIf="loading" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شماره رسید</th>
              <th>مشتری</th>
              <th>تاریخ ثبت</th>
              <th>تاریخ ثبت فاکتور</th>
              <th>محل انجام کار</th>
              <th>تعداد تجهیزات</th>
              <th>وضعیت فاکتور</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of list
              | filter:Filter_title:'customerName'
              | paginate: {
                  id: 'LetterrequestcustomerFactor2Table',
                  itemsPerPage: 50,
                  currentPage: page,
                  totalItems: (list | filter:Filter_title:'customerName').length
                }">
              <td>{{ list.indexOf(item) + 1 }}</td>
              <td>{{ item.code || item.calibrationId }}</td>
              <td>{{ item.customerName || '-' }}</td>
              <td>{{ item.subDatePersian || '-' }}</td>
              <td>{{ item.factorConfirmDatePersian || '-' }}</td>
              <td>{{ item.locationName || (item.inLocation ? 'سایت' : 'آزمایشگاه') }}</td>
              <td>{{ item.totalDeviceCount | number }}</td>
              <td>
                <span *ngIf="isFactorConfirmed(item)" class="badge badge-success">فاکتور شده</span>
                <span *ngIf="!isFactorConfirmed(item)" class="badge badge-danger">فاکتور نشده</span>
              </td>
              <td>
                <button type="button" class="btn btn-warning" (click)="showDetail(item)">
                  <i class="fa fa-eye"></i> مشاهده جزئیات
                </button>
                <button *ngIf="!isFactorConfirmed(item)" type="button" class="btn btn-success"
                  style="margin-right: 5px;" [disabled]="confirmingId !== null"
                  (click)="openFactorConfirmModal(factorConfirmTemplate, item)">
                  <i class="fa fa-check"></i> فاکتور ثبت شد
                </button>
                <img *ngIf="confirmingId === item.calibrationId" src="assets/Loading.gif"
                  style="width: 25px; margin-right: 5px;" />
              </td>
            </tr>
            <tr *ngIf="!loading && list.length === 0">
              <td colspan="9">رسید تایید نهایی شده‌ای وجود ندارد.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="LetterrequestcustomerFactor2Table" nextLabel="بعدی" previousLabel="قبلی"
      (pageChange)="page = $event"></pagination-controls>
  </div>
</div>

<ng-template #factorConfirmTemplate>
  <div class="modal-header" dir="rtl">
    <h4 class="modal-title pull-left">ثبت نهایی فاکتور رسید شماره '{{ selectedFactorReceipt?.code }}'</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="confirmModalRef.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" dir="rtl">آیا از ثبت نهایی فاکتور اطمینان دارید؟</div>
  <div class="modal-footer" dir="rtl">
    <button type="button" class="btn btn-warning" [disabled]="confirmingId !== null" (click)="confirmFactor()">
      بله، فاکتور ثبت شد <i class="fa fa-check"></i>
    </button>
    <button type="button" class="btn btn-danger" [disabled]="confirmingId !== null"
      (click)="confirmModalRef.hide()">انصراف</button>
  </div>
</ng-template>
